<template>
  <!--
        作者：gmshop
        时间：2020-06-08
        描述：超链接选择-页面
    -->
    <el-select v-model="activePage" placeholder="请选择" class="percent-w100" @change="changeFunc" value-key="url">
        <el-option v-for="item in pages" :key="item.url" :value-key="item.name" :label="item.name" :value="item"></el-option>
    </el-select>
</template>

<script>
    export default{
        data(){
            return {
                /*页面数据*/
                pages: [
                    {
                        url: 'pages/index/index',
                        name: '首页',
                        type: '页面'
                    },
                    {
                        url: 'pages/product/category',
                        name: '分类',
                        type: '页面'
                    },
                    {
                        url: 'pages/cart/cart',
                        name: '购物车',
                        type: '页面',
                    },
                    {
                        url: 'pages/user/index/index',
                        name: '我的',
                        type: '页面',
                    },
                    {
                        url: 'pages/user/my-wallet/widthdrawlist',
                        name: '余额提现记录',
                        type: '页面',
                    },
                    {
                        url: 'pages/user/my-wallet/widthdraw',
                        name: '余额提现',
                        type: '页面',
                    },
                    {
                        url: 'pages/plus/transfer/balance/balance',
                        name: '余额转账',
                        type: '页面',
                    },
                    {
                        url: 'pages/agent/index/index',
                        name: '分销中心',
                        type: '页面',
                    },
                    {
                        url: 'pages/user/address/address',
                        name: '收货地址',
                        type: '页面',
                    },
                    {
                        url: 'pages/user/set/set',
                        name: '设置',
                        type: '页面',
                    },
                    {
                        url: 'pages/user/my-coupon/my-coupon',
                        name: '我的优惠券',
                        type: '页面',
                    },
                    {
                        url: 'pages/article/list/list',
                        name: '文章首页',
                        type: '页面',
                    },
                    {
                        url: 'pages/upgrade/upgrade',
                        name: '我要升级',
                        type: '页面',
                    },
                    {
                        url: 'pages/product/consumption',
                        name: '快速下单',
                        type: '页面',
                    },
                    {
                        url: 'pages/user/apply/apply',
                        name: '会员升级申请',
                        type: '页面',
                    },
                    {
                        url: 'pages/user/apply/index',
                        name: '升级申请列表',
                        type: '页面',
                    },
                    {
                        url: 'pages/user/my-store/apply/apply',
                        name: '门店申请',
                        type: '页面',
                    },
                    {
                        url: 'pages/user/my-store/apply/index',
                        name: '门店申请列表',
                        type: '页面',
                    },
                    {
                        url: 'pages/order/store-order/myorder',
                        name: '门店订单列表',
                        type: '页面',
                    },
                    {
                        url: 'application/reservation/list/list',
                        name: '预约服务',
                        type: '页面',
                    },
                    {
                        url: 'application/customization/my-customization-order',
                        name: '我的定制订单',
                        type: '页面',
                    },
                    {
                        url: 'application/sauce/index',
                        name: '商品定制',
                        type: '页面',
                    },
                    {
                        url: 'pages/agent/qrcode/qrcode',
                        name: '推广二维码',
                        type: '页面',
                    },
                    {
                        url: 'pages/plus/gradecard/index',
                        name: '会员卡激活',
                        type: '页面',
                    },
                    {
                        url: 'application/user/contacts/list',
                        name: '我的联系人',
                        type: '页面',
                    },
                    {
                        url: 'application/user/gcard/list',
                        name: '我的卡券',
                        type: '页面',
                    },
                    {
                        url: 'pages/user/my-bargain/my-bargain',
                        name: '我的砍价',
                        type: '页面',
                    },
                    {
                        url: 'pages/order/member-card',
                        name: '会员卡',
                        type: '页面',
                    },
                    {
                        url: 'pages/user/collect/collect',
                        name: '我的收藏',
                        type: '页面',
                    },
                ],
                detect: [
                  {
                      auth: '/pages/upgrade/upgrade',
                      url: [
                        'pages/upgrade/upgrade',
                      ],
                      name: '我要升级',
                  },
                  {
                      auth: '/user/review/index',
                      url: [
                        'pages/user/apply/apply',
                        'pages/user/apply/index',
                      ],
                      name: '会员升级申请',
                  },
                  {
                      auth: '/store/review/index',
                      url: [
                        'pages/user/my-store/apply/apply',
                        'pages/user/my-store/apply/index',
                      ],
                      name: '门店申请',
                  },
                  {
                      auth: '/customization/order/index',
                      url: [
                        'application/customization/my-customization-order',
                        'application/sauce/index',
                      ],
                      name: '定制订单',
                  },
                  {
                      auth: '/plus/gradecard/index',
                      url: [
                        'pages/plus/gradecard/index',
                      ],
                      name: '会员卡激活',
                  },
                  {
                      auth: '/gcard',
                      url: [
                        'application/user/gcard/list',
                      ],
                      name: '我的卡券',
                  },
                  {
                      auth: '/plus/bargain/index',
                      url: [
                        'pages/user/my-bargain/my-bargain',
                      ],
                      name: '我的砍价',
                  },
                  {
                      auth: '/plus/userupgrade/memberCard',
                      url: [
                        'pages/order/member-card',
                      ],
                      name: '会员卡',
                  },
                ],
                /*选中的值*/
                activePage: '首页'
            }
        },
        created() {
          /*是否授权*/
          this.detect.forEach(item => {
            if(!this.$filter.isAuth(item.auth)){
              let arr = [];
              this.pages.forEach(item1 => {
                if(!item.url.includes(item1.url)){
                  arr.push(item1);
                }
                this.pages = arr;
              });
            }
          });
          /*初始化*/
          this.changeFunc(this.pages[0]);
        },
        methods: {
            /*选中的值*/
            changeFunc(e){
                this.$emit('changeData', e);
            }
        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/setlink/part/Pages.vue